import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import ChatMessage from "./ChatMessage";
import {
  MessagesContainer,
  MessageRow,
  MessageBubble,
  TypingDot,
} from "./chatbot.styled";

const ChatMessages = ({ messages, loading }) => {
  const { t } = useTranslation();
  const bottomRef = useRef(null);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, loading]);

  return (
    <MessagesContainer>
      {messages.map((msg) => (
        <ChatMessage key={msg.id} message={msg} />
      ))}
      {loading && (
        <MessageRow isBot>
          <MessageBubble isBot>
            {t('chatbot.loading.retrievingInformation')}<TypingDot>.</TypingDot><TypingDot>.</TypingDot><TypingDot>.</TypingDot>
          </MessageBubble>
        </MessageRow>
      )}
      <div ref={bottomRef} />
    </MessagesContainer>
  );
};

export default ChatMessages;
